<template>
    <div>
        <InfoUser v-on:changeActiveCard='data=> emitToParent("changeActiveCard",this,data)' v-on:userData='data => emitToParent("userData",this,data)' v-bind="userData"/>
        <div class="innerContainer">
          <FormEditUser v-on:openPopup='data => emitToParent("openPopup",this,data)' v-on:retrieveMyUser='() => emitToParent("retrieveMyUser",this)' v-on:userData='data => emitToParent("userData",this,data)' v-bind="userData" :privacy="privacy" :terms="terms"/>
          <RightColumnAds :images="banners"/>
        </div>
        <ModalNovosTermos/>
    </div>
</template>
<style lang="scss">
</style>

<script>
// @ is an alias to /src
import InfoUser from '@/components/InfoUser.vue'
import RightColumnAds from '@/components/RightColumnAds.vue'
import FormEditUser from '@/components/FormEditUser.vue'
import {emitToParent,scrollTop, redirect} from '../helpers/helpers'
import {get} from '../services/image.service'
import ModalNovosTermos from '@/components/ModalNovosTermos.vue'

export default {
  name: 'dados',
  components: {
      InfoUser,
      RightColumnAds,
      FormEditUser,
      ModalNovosTermos
  },
  data() {
    return {
      banners: [],
    }
  },
  methods:{
    emitToParent,
    loadBanner: function() {
      if(this.banners.length) return;
      get("Dados").then(r => {
        this.banners = r.data.sort((a, b) => a.position - b.position);
      })
    }
  }, 
  props:{
     userData:{
      type:Object
    },
    privacy:{
      type:Object
    },
    terms:{
      type:Object
    },
  },
  mounted(){
    if(!sessionStorage.getItem("giro-token")) redirect("login",this)
    scrollTop()
    //emitToParent("getImage",this,"Dados")
    //console.log(this.imagesObject);
    this.loadBanner();

  }
}
</script>
